var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 90,
    viewBox: "0 0 128 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 38.4C26.26 38.4 32 32.66 32 25.6C32 18.54 26.26 12.8 19.2 12.8C12.14 12.8 6.4 18.54 6.4 25.6C6.4 32.66 12.14 38.4 19.2 38.4ZM108.8 38.4C115.86 38.4 121.6 32.66 121.6 25.6C121.6 18.54 115.86 12.8 108.8 12.8C101.74 12.8 96 18.54 96 25.6C96 32.66 101.74 38.4 108.8 38.4ZM115.2 44.8H102.4C97.4035 44.8 97.8522 50.9895 101.189 54.7081C102.662 56.349 103.95 58.1556 105.023 60.0984C108.038 65.5595 113.066 70.4 119.304 70.4H121.6C125.14 70.4 128 67.54 128 64V57.6C128 50.54 122.26 44.8 115.2 44.8ZM64 44.8C76.38 44.8 86.4 34.78 86.4 22.4C86.4 10.02 76.38 0 64 0C51.62 0 41.6 10.02 41.6 22.4C41.6 34.78 51.62 44.8 64 44.8ZM79.36 51.2C78.2673 51.2 77.1937 51.4577 76.1872 51.8829C72.4301 53.47 68.3313 54.4 64 54.4C59.6669 54.4 55.5821 53.4692 51.8137 51.8809C50.8067 51.4565 49.7328 51.2 48.64 51.2C35.92 51.2 25.6 61.52 25.6 74.24V80C25.6 85.3 29.9 89.6 35.2 89.6H92.8C98.1 89.6 102.4 85.3 102.4 80V74.24C102.4 61.52 92.08 51.2 79.36 51.2ZM26.8101 54.7076C30.1482 50.9898 30.5965 44.8 25.6 44.8H12.8C5.74 44.8 0 50.54 0 57.6V64C0 67.54 2.86 70.4 6.4 70.4H8.68668C14.9221 70.4 19.9502 65.5697 22.9653 60.1118C24.0415 58.1637 25.3333 56.3524 26.8101 54.7076Z",
    fill: "url(#paint0_linear_344_774)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_344_774",
    x1: -30.2796,
    y1: 89.6,
    x2: 282.495,
    y2: 89.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.3e9b6e8d711cfeb1387acfa25aa8d5c3.svg";
export { ForwardRef as ReactComponent };